






























































































import { Component, Vue, Watch } from "vue-property-decorator";
import { LoginInfo } from "@/req/login";
import router from "../../router/router";
@Component
export default class Logout extends Vue {
  public loginShow = 11;
  public pwdshow = "icons/login3.png";
  public flg = true;
  public clause = true;
  public errorHint = false;
  public exist = false;
  public hint = false; // 提示弹框
  public msgs = "账号密码输入错误";
  public products: any = [];
  public selectLogin = false;
  public accord = false;
  public isDisable = false;
  public formLogin = {
    username: "",
    password: "",
    save: false,
  };

  @Watch("formLogin", { deep: true })
  public handleWatch() {
    if (this.formLogin.username !== "" || this.formLogin.password !== "") {
      this.exist = true;
      return;
    }
    this.exist = false;
  }
  // public selectChange() {
  //   this.selectLogin = true;
  //   if (localStorage.getItem("temp") != null && localStorage.getItem("temp") != undefined) {
  //     const tempObj = (JSON.parse as any)(localStorage.getItem("temp"));
  //     this.products = JSON.parse(JSON.stringify(tempObj));
  //   }
  //   this.products = this.products.filter((item, index) => {
  //     return this.formLogin.username == item.username.substring(0, this.formLogin.username.length);
  //   })
  // }
  public skipPage(id) {
    if (id == 2) {
      this.$fn.userRecord(3105, 2);
      this.$fn.userRecord(3000, 1);
    }
    if (id == 3) this.$emit("loginShow", "");
    this.$emit("login", id);
  }

  // 获取焦点
  public foucs(val) {
    this.errorHint = false;
    if (val == "user") this.$fn.userRecord(3101, 3);
    if (val == "password") return this.$fn.userRecord(3102, 3);
    if (this.formLogin.username == "") {
      this.selectLogin = true;
      this.formLogin.password = "";
    }
  }

  // 失去焦点
  public blur() {
    setTimeout(() => {
      this.selectLogin = false;
    }, 400);
    if (this.formLogin.username.length < 6)
      return this.msgTs("账号不能小于六位");
    this.errorHint = false;
  }
  public pwdblur() {
    if (this.formLogin.password.length < 6)
      return this.msgTs("密码不能小于六位");
  }
  public msgTs(val) {
    this.msgs = val;
    this.errorHint = true;
  }

  // 账号密码渲染
  // public savePassword() {
  //   if (localStorage.getItem("temp") != null && localStorage.getItem("temp") != undefined) {
  //     const tempObj = (JSON.parse as any)(localStorage.getItem("temp"));
  //     this.products = JSON.parse(JSON.stringify(tempObj));
  //     this.formLogin = tempObj[0];
  //   }
  //   if (localStorage.getItem("tempLogin") != null && localStorage.getItem("tempLogin") != undefined) {
  //     // 自动登录判断
  //     const loginObj = (JSON.parse as any)(localStorage.getItem("tempLogin"));
  //     if (loginObj.accord) {
  //       this.accord = loginObj.accord;
  //       this.toLogin();
  //     }
  //   }
  // }
  // 切换账号
  // public changeLogin(index) {
  //   this.products.map((item, ids) => {
  //     if (index == ids) {
  //       this.formLogin = JSON.parse(JSON.stringify(item));
  //     }
  //   });
  //   this.selectLogin = false;
  //   this.errorHint = false;
  // }
  // 登录
  public lognext() {
    this.$fn.userRecord(3103, 2);
    if (!this.clause) {
      this.hintsh();
      return;
    }
    this.login();
  }
  // 勾选提示
  public hintsh() {
    this.hint = true;
    setTimeout(() => {
      this.hint = false;
    }, 2000);
  }
  public clearBlank() {
    // 只允许出现数字和字母
    this.formLogin.username = this.formLogin.username.replace(
      /[^a-zA-Z0-9_]/g,
      ""
    );
  }
  public clearSpace() {
    this.formLogin.password = this.formLogin.password.replace(
      /[^a-zA-Z0-9]/g,
      ""
    );
  }
  public onSave() {
    this.formLogin.save = !this.formLogin.save;
  }

  public login() {
    if (!this.clause) {
      this.hint = true;
    }
    this.isDisable = true;
    setTimeout(() => {
      this.hint = false;
      this.isDisable = false;
    }, 2000);
    if (this.formLogin.username.length < 6)
      return this.msgTs("账号不能小于六位");
    if (this.formLogin.password.length < 6)
      return this.msgTs("密码不能小于六位");
    if (this.accord == true && this.formLogin.save != true) {
      this.msgTs("自动登录需记住密码");
      return;
    }
    this.toLogin();
  }
  public async toLogin() {
    this.errorHint = false;
    const objData = {
      username: this.formLogin.username,
      password: this.formLogin.password,
    };
    const res = await LoginInfo(objData);
    if (res.code == 200) {
      if (!res.data.userinfo.phone) {
        this.skipPage(3);
        this.$emit("loginShow", objData);
        return;
      }
      this.$fn.cookies.setToken(res.data.token);
      localStorage.setItem("loginMethod", "password");
      this.$fn.userRecord(3106, 1);
      // const arrList = [];
      // const savePass = {
      //   username: this.formLogin.username,
      //   password: this.formLogin.password,
      //   save: this.formLogin.save,
      //   clause: this.clause
      // };
      // if (!this.formLogin.save) {
      //   savePass.password = "";
      //   savePass.clause = false;
      // }
      // if (localStorage.getItem("temp") != null) {
      //   const tempObj = (JSON.parse as any)(localStorage.getItem("temp"));
      //   tempObj.unshift(savePass);
      //   let len = tempObj.length;
      //   for (let i = 0; i < len; i++) {
      //     for (let j = i + 1; j < len; j++) {
      //       if (tempObj[i].username === tempObj[j].username) {
      //         tempObj.splice(j, 1);
      //         j--;
      //         len--;
      //       }
      //     }
      //   }
      // const saveObj = JSON.stringify(tempObj);
      // localStorage.setItem("temp", saveObj);
      // }
      //  else {
      // (arrList as any).unshift(savePass);
      // const saveObj = JSON.stringify(arrList);
      // localStorage.setItem("temp", saveObj);
      // }
      // 自动登录状态判断
      // const loginPass = {
      //   accord: this.accord,
      // };
      // const loginObj = JSON.stringify(loginPass);
      // localStorage.setItem("tempLogin", loginObj);
      (window as any).location.reload();
      (this as any).$toast(false);
    } else {
      this.msgTs(res.msg);
      this.errorHint = true;
    }
  }
  // 删除历史账号
  // public del(id) {
  //   this.errorHint = false;
  //   const uname = this.products[id].username;
  //   const tempObj = (JSON.parse as any)(localStorage.getItem("temp"));
  //   this.products = JSON.parse(JSON.stringify(tempObj));
  //   this.products.some((item, index) => {
  //     if (item.username == uname) {
  //       this.products.splice(index, 1);
  //     }
  //   })
  //   const loginObj = JSON.stringify(this.products);
  //   localStorage.setItem("temp", loginObj);
  //   if (localStorage.getItem("temp") == "[]") {
  //     localStorage.removeItem("temp");
  //   }
  // }
  public pwdsh() {
    this.pwdshow = this.flg ? "icons/login6.png" : "icons/login3.png";
    this.flg = !this.flg;
  }
  public getImgUrl() {
    return require(`@/assets/${this.pwdshow}`);
  }
  public getUrl(val) {
    let url: any = "";
    if (!(val === "serve")) {
      url = "http://list.dhsf.xqhuyu.com/Privacy-policy.html";
    } else {
      url = "http://list.dhsf.xqhuyu.com/user-agreement.html";
    }
    window.open(url);
  }
}
